import { AccountOverlay } from '~domain/entities/AccountOverlay';
import { diContainer, serviceNames } from '~setup/diContainer';

export class AccountSidebarVisibilityUseCase {
    private isOpen: boolean;
    private overlay: AccountOverlay;

    constructor(isOpen: boolean) {
        this.isOpen = isOpen;
        this.overlay = diContainer.get(serviceNames.accountOverlay);
    }

    public execute() {
        this.overlay.setVisibility(this.isOpen);
    }
}
